import { gql } from 'apollo-boost'

export const NOTE = gql`
  query getMemberNote($data: getMemberNote) {
    getMemberNote(data: $data)
  }
`
